module.exports = __webpack_public_path__ + "static/img/onOther.8006cb79.png";